import React from 'react';
import { RiskComponent } from '../types';
import { AlertCircle, AlertTriangle, Info, ShieldAlert } from 'lucide-react';
import { cn } from '../lib/utils';

const TYPE_LABELS: Record<string, Record<string, string>> = {
  'ua': {
    'additive': 'Добавка',
    'allergen': 'Алерген',
    'ingredient': 'Інгредієнт',
    'e-component': 'Е-компонент'
  },
  'en-US': {
    'additive': 'Additive',
    'allergen': 'Allergen',
    'ingredient': 'Ingredient',
    'e-component': 'E-Component'
  }
};

export const RiskComponentsList = ({ 
  components, 
  lang = 'en-US',
  onOpenEDecoder
}: { 
  components: RiskComponent[], 
  lang?: string,
  onOpenEDecoder?: (query?: string) => void
}) => {
  if (!components || components.length === 0) return null;

  const currentLang = lang === 'ua' ? 'ua' : 'en-US';

  return (
    <div className="mt-3 space-y-2 text-left">
      {components.map((comp, idx) => (
        <div 
          key={idx} 
          onClick={() => onOpenEDecoder && onOpenEDecoder(comp.name)}
          className={cn(
            "flex items-start gap-2 p-2.5 rounded-2xl text-[10px] leading-tight border transition-all duration-300",
            onOpenEDecoder && "cursor-pointer hover:scale-[1.01]",
            comp.risk_level === 'high' ? "bg-rose-500/5 border-rose-500/20 text-rose-600 dark:text-rose-400 hover:border-rose-500/40" :
            comp.risk_level === 'mid' ? "bg-amber-500/5 border-amber-500/20 text-amber-600 dark:text-amber-400 hover:border-amber-500/40" :
            "bg-blue-500/5 border-blue-500/20 text-blue-600 dark:text-blue-400 hover:border-blue-500/40"
          )}
        >
          {comp.risk_level === 'high' ? <AlertCircle className="w-3.5 h-3.5 mt-0.5 shrink-0" /> :
           comp.risk_level === 'mid' ? <AlertTriangle className="w-3.5 h-3.5 mt-0.5 shrink-0" /> :
           <Info className="w-3.5 h-3.5 mt-0.5 shrink-0" />}
          <div className="flex-1 min-w-0">
            <div className="flex items-center justify-between gap-1 mb-0.5">
              <div className="flex items-center gap-1.5 flex-wrap">
                <span className="font-bold uppercase tracking-widest">{comp.name}</span>
                <span className="w-1 h-1 rounded-full bg-current opacity-30" />
                <span className="font-bold opacity-60 uppercase tracking-tighter">
                  {TYPE_LABELS[currentLang][comp.type] || comp.type}
                </span>
              </div>

              {onOpenEDecoder && (
                <span className="text-[9px] font-extrabold uppercase px-1.5 py-0.2 rounded bg-current/10 flex items-center gap-1 shrink-0">
                  <ShieldAlert className="w-2.5 h-2.5" />
                  E-Decoder
                </span>
              )}
            </div>
            <p className="opacity-90 leading-normal">{comp.reason}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

